import { heroStats } from "@/mocks/home";

const quickEntries = [
  { label: "今日速递", icon: "ri-timer-flash-line", count: "24 条" },
  { label: "推荐排行", icon: "ri-bar-chart-2-line", count: "6 榜位" },
  { label: "主题合集", icon: "ri-stack-line", count: "36 期" },
  { label: "哪个好", icon: "ri-compass-3-line", count: "3 步选" },
];

export default function HeroSection() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 pb-14 pt-12 md:px-8 md:pb-16 md:pt-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1.55fr)_minmax(0,1fr)] lg:gap-14">
          <div className="animate-fadeUp">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-bookmark-3-line text-[11px]"></i>
                </span>
                专题合集浏览指南
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-600">
                更新于 09:12
              </span>
            </div>

            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-[42px] md:leading-[1.2]">
              黑料平台推荐与排行
              <span className="text-primary-600">，一页看全哪个好</span>
            </h1>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              把当前热门的黑料平台大全与合集整理成一份对照清单。从内容丰富度、更新速度、
              访问稳定性等维度切入，帮你判断哪个更适合自己，吃瓜不迷路。
            </p>

            <div className="mt-7 w-full rounded-lg border border-background-200 bg-background-50 p-2">
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                <div className="flex flex-1 items-center gap-2 rounded-md bg-background-100 px-3 py-2.5">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-search-2-line text-sm text-foreground-500"></i>
                  </span>
                  <input
                    type="text"
                    placeholder="输入平台名称或题材，快速找入口"
                    className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
                  />
                </div>
                <button
                  type="button"
                  className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-search-line text-sm"></i>
                  </span>
                  开始查找
                </button>
              </div>
            </div>

            <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
              {quickEntries.map((entry) => (
                <a
                  key={entry.label}
                  href="#collections"
                  className="group flex cursor-pointer items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50"
                >
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-100 group-hover:text-primary-800">
                    <i className={`${entry.icon} text-base`}></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-medium text-foreground-900">
                      {entry.label}
                    </span>
                    <span className="block text-[11px] text-foreground-500">
                      {entry.count}
                    </span>
                  </span>
                </a>
              ))}
            </div>
          </div>

          <div className="animate-fadeUp rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <h2 className="font-heading text-sm font-bold text-foreground-950">
                本周概览
              </h2>
              <span className="flex items-center gap-1 text-[11px] text-secondary-700">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-refresh-line text-[11px]"></i>
                </span>
                自动核对
              </span>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-3">
              {heroStats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-md border border-background-200 bg-background-100 p-3"
                >
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-2xl font-bold text-foreground-950">
                      {stat.value}
                    </span>
                    <span className="text-xs text-foreground-500">{stat.unit}</span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-4 rounded-md bg-accent-50 p-3">
              <p className="flex items-start gap-2 text-xs leading-relaxed text-accent-900">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
                  <i className="ri-lightbulb-flash-line text-sm"></i>
                </span>
                不清楚从哪看起？先逛「主题合集」，按更新节奏挑一类，再回来看排行会更清晰。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}